import React from 'react';
import FiftyFifty from './FiftyFifty';

import Map1Img from '../../statics/img/map1.jpg';
import Map2Img from '../../statics/img/map2.jpg';
import Map3Img from '../../statics/img/map3.png';
import { FEDRAL_DATASETS_AGOL_GROUP } from '../../constants/map';

const FiftyFiftyContainer = () => {
    return (
        <div>
            <FiftyFifty
                imageURL={Map1Img}
                title={'A Wealth of Open Data'}
                content={
                    <>
                        <p className="mb-4">
                            U.S. federal agencies excel at creating and managing
                            critical geospatial data to meet agency needs. For
                            years, the public and private sectors have accessed
                            these free and open datasets through downloadable
                            packages. Even more recently, agencies have
                            developed more modern and easy-to-use enterprise web
                            services of their data.
                        </p>
                        <p>
                            The emergence of geoportals, providing access to
                            their web services, maps, and apps, has accelerated
                            the ability to find, consume, and use this wealth of
                            data. However, these are widely distributed sites
                            with varying documentation, performance,
                            discoverability, and scaling capabilities. Today,
                            Esri is making this collection of geospatial
                            datasets as Findable, Accessible, Interoperable, and
                            Reusable using{' '}
                            <a
                                href="https://www.go-fair.org/fair-principles/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                FAIR Principles
                            </a>
                            .
                        </p>
                    </>
                }
            />
            <FiftyFifty
                imageURL={Map2Img}
                reversed={true}
                title={'Empowering Decision Making'}
                content={
                    <>
                        <p className="mb-4">
                            This collection of cached federal services and maps
                            is now available in a curated, Esri-managed group in
                            ArcGIS Online called the{' '}
                            <a
                                href="https://fedmaps.maps.arcgis.com/home/group.html?id=8c90888d825d440a9e4754fda9e4e92e&view=grid#content"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Esri Federal Datasets
                            </a>
                            . To government users, this is the collection of
                            data known as A-16 or NGDA Datasets. To everyone
                            else, this is a fantastic collection of nearly 100
                            national geospatial datasets on topics like census,
                            energy leases, dams, bridges, federal public lands,
                            runways, rail nodes, and many more.
                        </p>

                        <p className="mb-4">
                            The collection serves the Esri and broader
                            geospatial user communities as well as open-source
                            and web developers. By centralizing access and
                            standardizing the underlying technology, Esri makes
                            it even easier to use and leverage these critical
                            data assets to make more informed decisions.
                        </p>

                        <p>
                            For the Esri community, you can connect to these
                            services in your maps and apps, and for the Open GIS
                            community, you can access these services through the
                            most modern OGC standards (
                            <a
                                href="https://www.ogc.org/standards/ogcapi-features"
                                target="_blank"
                                rel="noreferrer"
                            >
                                OGC API – Features
                            </a>
                            ).
                        </p>
                    </>
                }
            />
            <FiftyFifty
                imageURL={Map3Img}
                title={'The Power of Integration'}
                content={
                    <>
                        <p className="mb-4">
                            Data-driven decision making does not follow the
                            structure of federal agencies. For instance, to
                            conduct an environmental impact assessment, data
                            from multiple agencies such as EPA, USGS, NOAA,
                            USFWS, and others might be needed. Creating this
                            centralized and cached set of resources not only
                            makes them more discoverable, but the individual
                            layers can also be more easily integrated into maps
                            for planning, analysis, sharing with
                            decision-makers, or even building into applications
                            for public consumption.
                        </p>
                        <p>
                            Explore Esri’s collection of National Geospatial
                            Open Data in the application below or access them
                            directly through ArcGIS Living Atlas of the World{' '}
                            <a
                                href={FEDRAL_DATASETS_AGOL_GROUP}
                                target="_blank"
                                rel="noreferrer"
                            >
                                group
                            </a>
                            .
                        </p>
                    </>
                }
            />
        </div>
    );
};

export default FiftyFiftyContainer;
